import React from 'react';
import { PalletBox } from '../../models/pallet-box';
import { useCurrentLocation } from '../../store/hooks/useCurrentLocation';
import momentTimezone from 'moment-timezone';
import { Location } from '../../models/location';
import { Tooltip } from '@cimpress/react-components';
import FontAwesomeTile from '../utils/FontAwesomeTile';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { useFeature } from '../../store/hooks/useFeature';
import { Features } from '../../models/features';

function getCutoffFlag(palletBox: PalletBox, location: Location) {
  const now = momentTimezone.tz(location.localeSettings.timezone);
  let cutoffMoment = momentTimezone.tz(`${now.format('YYYY-MM-DD')} 15:00`, location.localeSettings.timezone);
  if (now.isBefore(cutoffMoment)) {
    cutoffMoment = cutoffMoment.subtract(momentTimezone.duration(1, 'days'));
  }
  if (cutoffMoment.isAfter(palletBox.createdAt)) {
    return `Pallet box created ${momentTimezone(palletBox.createdAt).fromNow()}`;
  }
  return;
}

function getBaseFlag(palletBox: PalletBox) {
  const cutoffMoment = momentTimezone.tz();
  cutoffMoment.subtract(momentTimezone.duration(1, 'days'));
  if (cutoffMoment.isAfter(palletBox.createdAt)) {
    return `Pallet box created ${momentTimezone(palletBox.createdAt).fromNow()}`;
  }
  return;
}

function getFlag(palletBox: PalletBox, location: Location, useCutoffFeature: boolean) {
  return useCutoffFeature ? getCutoffFlag(palletBox, location) : getBaseFlag(palletBox);
}

export interface PalletBoxFlagProps {
  palletBox: PalletBox;
}

// tslint:disable-next-line:function-name
export default function PalletBoxFlag({
  palletBox,
}: PalletBoxFlagProps) {
  const location = useCurrentLocation();
  const { isLoading, value: useCutoffFeature } = useFeature(Features.EXPERIMENTAL_PB_FLAG);
  const flag = getFlag(palletBox, location, useCutoffFeature);
  if (isLoading) {
    return null;
  }
  return flag &&
    <Tooltip contents={flag} direction="right">
      <FontAwesomeTile
        icon={faClock}
        color="var(--danger)"
        size="1x"
      />
    </Tooltip> || null;
}
